export enum ParameterType {
    Text = 1,
    Date,
    Numeric,
    LOV,
    None
}
